import React, { FC } from 'react';
import classNames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { LazyOnlyImageProps } from './interfaces';

import useStyles from './style';

const LazyImage: FC<LazyOnlyImageProps> = ({
  setIsLoadError,
  handleLoadError,
  src,
  debounceLoadMs = 300,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <LazyLoadImage
      src={src}
      delayTime={debounceLoadMs}
      onLoad={() => setIsLoadError(false)}
      onError={() => handleLoadError()}
      placeholder={
        <div className={classNames('imagePlaceholder intrinsic-item', classes.imagePlaceholder)} />
      }
      {...rest}
    />
  );
};

export default LazyImage;
